import { Box, IconButton, Icon } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import Grid from '@mui/material/Grid';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableBody';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Link from "@mui/material/Link";
import { toast } from 'react-toastify';
import '../../assets/style/style.css';
import productNoImage from "../../assets/images/no-image.png";
import { useMaterialUIController, setOrderContext } from "context";
import { handleErrors } from "common.js";

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { useParams, useNavigate } from 'react-router-dom';
import Card from "@mui/material/Card";
import configurations from "config";
import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import ShowTrackShipmentPopup from './components/ShowTrackShipmentPopup';
import MDTypography from "components/MDTypography";

function FulfillmentList(props) {
  const [controller, dispatch] = useMaterialUIController();
  const { orderContext } = controller;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const orderID = props.orderID;
  const setLoading = props.setLoading;
  const fulfillmentDetails = orderContext.fulfilledTableData;
  const [downloadUrl,setDownloadUrl] = useState([]);
  const [trackShipmentDetails, setTrackShipmentDetails] = useState('')
  const [showTrackShipmentDetails, setShowTrackShipmentDetails] = useState(false);
  const [fulfillmentSyncLoading, setFulfillmentSyncLoading] = useState({});
  const [fulfillmentSyncButtonHide, setFulfillmentSyncButtonHide] = useState({});
  const [fulfillmentCancelButtonShow, setFulfillmentCancelButtonShow] = useState({});
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [fulfillmentDeletePayload, setFulfillmentDeletePayload] = useState({});

  const handleConfirmationDialogOpen = (fulfillmentID) => {
    setFulfillmentDeletePayload({ fulfillmentID: fulfillmentID });
    setConfirmationDialogOpen(true);
  };

  const handleConfirmationDialogClose = () => {
    setFulfillmentDeletePayload({});
    setConfirmationDialogOpen(false);
  };

  const handleTrackShipment = async (wayBillNo) => {

    setLoading(true)
    axios.get(baseUrl + '/order/track-shipment/' + wayBillNo, {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
    }).then((response) => {
      setLoading(false)
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setTrackShipmentDetails(response.data.data.ShipmentData[0]);
          setShowTrackShipmentDetails(true);
        }
        else {
          if (message != '')
            toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
        }
      }
      else {
        toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
      }
    }).catch(error => {
      setLoading(false)
      handleErrors(error, t, navigate);
    });

  }

  const handleSyncFulfillment = async (fulfillmentID) => {

    setFulfillmentSyncLoading((prevState) => ({
      ...prevState,
      [fulfillmentID]: true,
    }));  

    let syncFulfillmentPayload = {
                                    fulfillmentID: fulfillmentID,
                                 }

    axios({    
      url     : baseUrl+"/order/sync-fulfillment-shopify",
      method  : "POST",
      data    : syncFulfillmentPayload,
      headers : {
        Authorization   : bearerToken,
        function        : azureFunctionVendorFrontendKey
      },      
    }).then(function (response) 
    {
        setFulfillmentSyncLoading({});

        const responseData           = response.data;
        const responseDataStatusCode = response.data.status;
        const responseStatusCode     = response.status;
        
        if(responseStatusCode === 200)
        {
            if(responseDataStatusCode === 0)
            {
              toast.error(t(response.data.message));
              return;
            }
            else if(responseDataStatusCode === 1)
            {
              toast.success(t(response.data.message)); 

              setFulfillmentSyncButtonHide((prevState) => ({
                ...prevState,
                [fulfillmentID]: true,
              }));  
              
              setFulfillmentCancelButtonShow((prevState) => ({
                ...prevState,
                [fulfillmentID]: true,
              })); 
              
              return;                 
            }
        }    
    }).catch(function (error) {
      setFulfillmentSyncLoading({});
      handleErrors(error, t, navigate);
    });
  } 

  const handleFulfillmentDelete = async () => {
 
    setLoading(true);
    setConfirmationDialogOpen(false);
    axios({    
          url     : baseUrl+"/order/delete-fulfillment",
          method  : "POST",
          data    : fulfillmentDeletePayload,
          headers : {
            Authorization   : bearerToken,
            function        : azureFunctionVendorFrontendKey
          },      
        }).then(function (response) 
        {
            setLoading(false);
            setFulfillmentDeletePayload({});

            const responseData           = response.data;
            const responseDataStatusCode = response.data.status;
            const responseStatusCode     = response.status;
            
            if(responseStatusCode === 200)
            {
                if(responseDataStatusCode === 0)
                {
                  toast.error(t(response.data.message));
                  return;
                }
                else if(responseDataStatusCode === 1)
                {
                  toast.success(t(response.data.message)); 

                  if(responseDataStatusCode === 1 && responseData && responseData.data)
                  {
                      const unfulfilledColumns  =  [
                        { label: `${t("Product ID")}`, field: "productId" },
                        { label: `${t("Image")}`, field: "image" },
                        { label: `${t("Product Name")}`, field: "title" },
                        { label: `${t("Unit Price")}`, field: "price" },
                        { label: `${t("Sku")}`,field: "sku" },
                        { label: `${t("Qty")}`, field: "quantity" },
                        { label: `${t("Qty Fulfilled")}`, field: "fulfilledQuantity" },
                        { label: `${t("Avl. Qty For Fulfill")}`, field: "quantityForFulfill" },
                        { label: `${t("Total")}`, field: "total" },
                      ];
  
                      const fulfilledColumns  =  [
                        { label: `${t("Product ID")}`, field: "productId" },
                        { label: `${t("Image")}`, field: "image" },
                        { label: `${t("Product Name")}`, field: "title" },
                        { label: `${t("Unit Price")}`, field: "price" },
                        { label: `${t("Sku")}`,field: "sku" },
                        { label: `${t("Qty Fulfilled")}`, field: "fulfilledQuantity" },
                        { label: `${t("Shipment Status")}`, field: "shipmentStatus" },
                      ];
  
                      var unfulfilledRows          = [];
                      var unfulfilledProductsCount = 0; 
                      var allItemsFulfilled        = true;
                      var orderStatus              = 'accepted';
                      var partiallyFulfilledFlag   = false;
  
                      responseData.data.orderItemList.map((item, index) => {
  
                        let productImage      = item.productImage ? item.productImage : productNoImage;
                            unfulfilledProductsCount  = (item.fulfillmentStatus === 'unfulfilled') ? unfulfilledProductsCount+1 : unfulfilledProductsCount;
                            
                            if(allItemsFulfilled)
                            allItemsFulfilled = (item.fulfillmentStatus === 'unfulfilled' || item.fulfillmentStatus === 'partially_fulfilled') ? false : true;
  
                            var tempData = {
                              "productId"  : "#"+item.vendorProductId,
                              "image"      : <Box className="productImageBox"><img className="productImage" src={productImage} alt={item.title}  /></Box>,
                              "title"      : <Box className="productTitleBox" title={item.title}>{item.title}</Box>,
                              "price"      : `₹${item.price.toFixed(2)}`,
                              "sku"        : item.sku ? item.sku : '-',
                              "quantity"   : item.quantity,
                              "fulfilledQuantity"   : item.fulfillableQuantity,
                              "quantityForFulfill" : (item.quantity - item.fulfillableQuantity),
                              "total"               : `₹${(item.price * item.quantity).toFixed(2)}`,
                            };
                        
                        unfulfilledRows.push(tempData);
                    });
  
                      var fulfillmentRowsList = [];
                      var fulfillmentItems    = responseData.data.fulfillmentDetails;
                      fulfillmentItems.map((item, index) => {
  
                        var fulfilledRows = [];
                        item.fulfilledItems.map((items, itemIndex) => {
                          
                        let productImage           = items.productImage ? items.productImage : productNoImage;
                            partiallyFulfilledFlag = true;
  
                        var tempData = {
                          "productId"  : "#"+items.vendorProductId,
                          "image"      : <Box className="productImageBox"><img className="productImage" src={productImage} alt={items.title}  /></Box>,
                          "title"      : <Box className="productTitleBox" title={items.title}>{items.title}</Box>,
                          "price"      : `₹${items.price.toFixed(2)}`,
                          "sku"        : items.sku ? items.sku : '-',
                          "fulfilledQuantity" : items.fulfilledQuantity,
                          "shipmentStatus" : item.shipmentStatus ?? "Manifested",
                        };
                        
                        fulfilledRows.push(tempData);
  
                        });
  
                        fulfillmentRowsList.push(fulfilledRows);
                    });
  
                    orderStatus   = allItemsFulfilled ? 'fulfilled' : partiallyFulfilledFlag ? 'partially_fulfilled' : 'accepted';
                    
                    setOrderContext(dispatch, { ...orderContext, 
                      unfulfilledTableData: { unfulfilledColumns, unfulfilledRows, unfulfilledProductsCount: unfulfilledProductsCount, totalOrderedProducts: responseData.data.totalOrderedProducts },
                      fulfilledTableData: { fulfilledColumns, fulfillmentRowsList, fulfillmentItems },
                      orderDetails: { ...orderContext.orderDetails, orderStatus: orderStatus, allItemsFulfilled: allItemsFulfilled },
                    }); 
                  }
                  
                  return;                 
                }
            }    
        }).catch(function (error) {
          setLoading(false);
          setFulfillmentDeletePayload({});
          handleErrors(error, t, navigate);
        });
  }  

  const confirmationModelLoad = () => {
    return (      
      <Dialog open={confirmationDialogOpen} onClose={handleConfirmationDialogClose}>
        <DialogTitle>{t("Confirm Delete")}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t("Are you sure you want to delete this item?")}            
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmationDialogClose} color="primary" disableRipple>
            {t("cancel")}
          </Button>
          <Button onClick={handleFulfillmentDelete} color="secondary" disableRipple>
            {t("Confirm Delete")}
          </Button>
        </DialogActions>
      </Dialog>
      );    
  }   

  const handleSlipCreation = async (wayBillNo) => {

    setLoading(true)
    axios.get(baseUrl + '/vendor/generate-packing-slip/' + wayBillNo, {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
    }).then((response) => {
      setLoading(false)
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setDownloadUrl(prevState => ({
            ...prevState,
            [wayBillNo]: response.data.data.packingSlipUrl,
          }));
          // setDownloadUrl(response.data.data.packingSlipUrl)
          toast.success(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
        }
        else {
          if (message != '')
            toast.error(t(message), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true })
        }
      }
      else {
        toast.error(t('unableToProccessRequest'), { position: toast.POSITION.TOP_CENTER, hideProgressBar: true });
      }
    }).catch(error => {
      setLoading(false)
      handleErrors(error, t, navigate);
    });

  }

  const handleDownload = async (packingSlipUrl, wayBillNo) => {

    const downloadLink = document.createElement('a');
    downloadLink.href = packingSlipUrl; // URL of the file to download
    downloadLink.download = wayBillNo; // Name of the downloaded file
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

  }

  return (
    <>
      {confirmationDialogOpen ? confirmationModelLoad() : <></>}

      {fulfillmentDetails.fulfillmentItems.map((item, index) => (
        <Grid item key={item.id} xs={12}>

          {index === 0 ?
            <Typography color="text.secondary" sx={{ fontSize: '20px' }} pt={1} gutterBottom>
              {t('Fulfilled Products')}
            </Typography>
            : <></>}

          <Card variant="outlined">
            <Grid item xs={12}>
              <Grid container spacing={0}>
                <Grid item sm={6} xs={12} px={2} py={2} display="flex">
                  <Box sx={{ border: '1px dashed grey', width: 'fit-content' }} px={1}>
                    <Typography color="text.secondary" sx={{ fontSize: '16px' }} pt={1} gutterBottom>
                      {new Date(item.fulfillmentDate).toLocaleString(undefined, { hour12: true })}
                    </Typography>
                  </Box>
    
                 {
                  (
		     item.shipmentStatus === "Manifested" || 
		     item.shipmentStatus === "In Transit" || 
		     item.shipmentStatus === "Pending" || 
		     item.shipmentStatus === "Open" || 
		     item.shipmentStatus === "Scheduled"
		  ) && 	
                  item.wayBillNo > 0 && 
                  (fulfillmentCancelButtonShow[item.id] || item.notifiedShopify === 1) ?      
                <>
                  <Box 
                    mx={2} 
                    mt={1} 
                    className="squareBoxDelete"
                    onClick={() => handleConfirmationDialogOpen(item.id)}
                    >
                    <DeleteIcon 
                      color="primary" 
                      fontSize="medium" 
                      titleAccess={t("Cancel Fulfillment")}                       
                    />                    
                  </Box>
                </>
                : <></>}

                </Grid>
                <Grid item sm={6} xs={12} px={2} py={2} display="flex" justifyContent="end"> 
                {!fulfillmentSyncButtonHide[item.id] && item.notifiedShopify === 0 ?      
                  <>                    
                      <Button
                              variant="contained"
                              sx={{color : '#FFFFFF'}} 
                              onClick={() => handleSyncFulfillment(item.id)}
                              disabled={fulfillmentSyncLoading[item.id]}
                              disableRipple
                            >
                              {t("Sync To Shopify")}
                      </Button>
                      
                      {fulfillmentSyncLoading[item.id] ?  
                        <Box mx={2} mt={1}>    
                              <CircularProgress size={30} sx={{color: '#1a90ff'}} />
                        </Box>       
                      : <></>}
                    
                  </>
                : <></>}
                </Grid>     
              </Grid>
              {fulfillmentDetails.fulfillmentRowsList[index] && fulfillmentDetails.fulfillmentRowsList[index].length > 0 ?
                <TableContainer>
                  <Table>
                    <TableHead key={1}>
                      <TableRow key={1}>
                        {fulfillmentDetails.fulfilledColumns.map((column, index) => (
                          <TableCell key={"key-" + index}>{column.label}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody key={2}>
                      {fulfillmentDetails.fulfillmentRowsList[index].map((row, index) => (
                        <TableRow key={index}>
                          {fulfillmentDetails.fulfilledColumns.map((column) => (
                            <TableCell key={column.field + '-' + index}>
                              {row[column.field]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  { item.wayBillNo ?            
                    <Grid container spacing={0}>
                      <Grid item sm={6} xs={12} px={2} py={1} display="flex">
                        <Typography color="text.secondary" sx={{ fontSize: '16px' }} pt={1} pr={1} gutterBottom>
                          {t("Tracking No")} : {item.wayBillNo}                        
                        </Typography>
                        <MDTypography
                          component="a"
                          href={configurations.delhiveryTrackUrl + item.wayBillNo}
                          variant="button"
                          fontWeight="bold"
                          color="info"
                          textGradient
                          target="_blank"
                          className="delhiveryLink"
                        >
                          {t('Tracking Url')}
                        </MDTypography>
                        <Button
                          variant="contained"
                          className='trackShipment'
                          onClick={() => handleTrackShipment(item.wayBillNo)}
                          disableRipple
                        >
                          {t("trackShipment")}
                        </Button>
                        <>
                        {showTrackShipmentDetails ?
                          <ShowTrackShipmentPopup
                            showTrackShipmentDetails={showTrackShipmentDetails}
                            setShowTrackShipmentDetails={setShowTrackShipmentDetails}
                            t={t}
                            trackShipmentDetails={trackShipmentDetails}
                          />
                          :
                          null
                        }
                        </>                     
                      </Grid>
                      <Grid item sm={6} xs={12} px={2} py={1} display="flex">
                        <Typography color="text.secondary" sx={{ fontSize: '16px' }} pt={1} pr={1} gutterBottom>
                          {t("packingSlip")}
                        </Typography>
                      
                        <Button
                          variant="contained"
                          className='genaratePackingSlip'
                          onClick={() => handleSlipCreation(item.wayBillNo)}
                          disableRipple
                        >
                          {t("generatePackingSlip")}
                        </Button>
                        {(downloadUrl[item.wayBillNo] || item.packingSlipUrl) ?
                          <Button
                            variant="contained"
                            className='downloadPackingSlip'
                            disableRipple
                            onClick={() => handleDownload(downloadUrl[item.wayBillNo] ? downloadUrl[item.wayBillNo] : item.packingSlipUrl, item.wayBillNo)}
                          >
                            {t("downloadPackingSlip")}<Icon className="closeIcon">download</Icon>
                          </Button>
                          :
                          null
                        }
                      </Grid>
                    </Grid>
                  : <></> }      
                </TableContainer>
                : <></>}
            </Grid>
          </Card>
        </Grid>
      ))
      }
    </>
  );
}
export default FulfillmentList;
